import React from 'react';
import DateInput from '../DateInput';
import moment from 'moment';
import { create } from 'react-test-renderer';
import { fireEvent, render, screen} from '@testing-library/react';

describe('DateInput Component', () => {
  jest.useFakeTimers().setSystemTime(new Date('2022-10-26'));
  
  it('should be defined', () => {
    render(<DateInput onChange={jest.fn()}/>);
    expect(screen.getByRole('textbox')).toBeInTheDocument()
  });

  it('popup opens', async () => {
    const { container } = render(<DateInput onChange={jest.fn()} />);
    fireEvent.click(screen.getByRole('textbox'));
    expect(container.getElementsByClassName('core-popup-menu-wrapper').length).toBe(1);
    expect(container.getElementsByClassName('core-calendar').length).toBe(1);
  });

  it('it calls onFocus', () => {
    const onFocus = jest.fn();
    render(<DateInput onFocus={onFocus} onChange={jest.fn()}/>);
    fireEvent.focus(screen.getByRole('textbox'));
    expect(onFocus).toHaveBeenCalledTimes(1);
  });
  
  it('renders proper date format', () => {
    const date = moment.utc(new Date());
    render(<DateInput selected={date} locale='en' dateFormat="MM/DD/YYYY" onChange={jest.fn()}/>);
    const props = DateInput.defaultProps;
    expect(screen.getByRole('textbox').value).toEqual(DateInput.formatDate(props, date));
  });

  it('is disabled', () => {
    render(<DateInput onChange={jest.fn()} disabled />);
    expect(screen.getByRole('textbox')).toBeDisabled();
  });

  it('is readOnly', () => {
    render(<DateInput onChange={jest.fn()} readOnly />);
    expect(screen.getByRole('textbox').readOnly).toBe(true);
  });
  
  it('shows notices', () => {
    const errorMessage = "This is an error";
    render(<DateInput onChange={jest.fn()} errorMessage={errorMessage} />);
    expect(screen.getByRole('img', { name: /error/ })).toBeInTheDocument();
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === errorMessage))
      .toBeInTheDocument();
    
    const warningMessage = "This is a warning";
    render(<DateInput onChange={jest.fn()} warningMessage={warningMessage} />);
    expect(screen.getByRole('img', { name: /warning/ })).toBeInTheDocument();
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === warningMessage))
      .toBeInTheDocument();
    
    const successMessage = "This is a success";
    render(<DateInput onChange={jest.fn()} successMessage={successMessage} />);
    expect(screen.getByRole('img', { name: /success/ })).toBeInTheDocument();
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === successMessage))
      .toBeInTheDocument();
    
    const infoMessage = "This is an info";
    render(<DateInput onChange={jest.fn()} infoMessage={infoMessage} />);
    expect(screen.getByRole('img', { name: /info/ })).toBeInTheDocument();
    expect(screen.getByText((content, element) => element.tagName.toLowerCase() === 'span' && content === infoMessage))
      .toBeInTheDocument();
  });

  it('should match snapshot', () => {
    const component = create(<DateInput onChange={jest.fn()}/>).toJSON();
    expect(component).toMatchSnapshot();
  });
});
